import React from 'react'
import R from 'ramda'

const SuggestionItem = ({onSelect, label, icon}) => {
  return <button onClick={onSelect} className="btn btn-link" style={{lineHeight:'50%'}}>
      {label}
    </button>;
}

const ServicesSuggestions =  ({options, onSelect}) => {
  const optionToSuggestionItem = option => {
    const splittedName = R.split(', ', option.name)
    const second = splittedName[1] ? ', ' + splittedName[1] : '' 
    const sanitized = splittedName[0] + second
    const optionToSelect = {
      description: option.name || "",
      type: option.type || "",
      coordinates: option.coordinates
    }

    return  <SuggestionItem
      key={option.name || option.type}
      label={sanitized}
      onSelect={_ => onSelect(optionToSelect)}/>;
  }
  
  return <div>
    {R.map(optionToSuggestionItem, options)}
  </div>
}

export default ServicesSuggestions



/** WEBPACK FOOTER **
 ** ./app/components/ServicesSuggestions.jsx
 **/